enum CheckoutFeedbackQuestionType {
  HOST_DEFAULT = "HOST_DEFAULT",
  HOST_TEXTAREA = "HOST_TEXTAREA",
  HOST_SELECT = "HOST_SELECT",
  TEXTAREA = "TEXTAREA",
  ICON = "ICON",
  BUTTON = "BUTTON",
}

type CheckoutFeedbackQuestionIcon =
  | "checkout_feedback.icon.bad"
  | "checkout_feedback.icon.regular"
  | "checkout_feedback.icon.good";

export type { CheckoutFeedbackQuestionIcon };
export { CheckoutFeedbackQuestionType };
